// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2y6dQ","colMaxWidth":"Table_colMaxWidth__2GCXO"};